<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">微信聊天</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">离线时长设置</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="data-list">
            <a-divider orientation="left">
            离线时长设置
            </a-divider>

            <div class="fpstyle" >
                <a-form :label-col="{ span: 3 }" :wrapper-col="{ span: 6 }">
                    <a-form-item label="离线时长">
                        <a-icon slot="prefix" type="clock-circle" />
                        <a-input style="width:120px" v-model="detail.duration"  suffix="分钟" />
                    </a-form-item>
                    <a-form-item :wrapper-col="{ span: 6, offset: 3 }">
                        <a-button type="primary" @click="tofptype">
                            确定
                        </a-button>
                    </a-form-item>
                </a-form>

                <p>离线时长设置：用户在离线时间内未和客服聊天将自动离线</p>

            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            type:"",
            detail:"",
            imid:"",
            stsid:""
        }
    },
    mounted(){
        // this.getdetail()
        this.personinfo()
    },
    methods:{

        personinfo(){
            this.$axios.post('/api/system/adminpage',{
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                
                if(res.data.code==200){
                    this.imid=res.data.data.imid      
                    this.getdetail()      
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        },
        
        onChange(e) {
            this.type=e.target.value
        },
        tofptype(){
            this.$axios.post('/api/wechat1/editseatdisconnect',{
                stsid:this.stsid,
                duration:this.detail.duration
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        },

        getdetail(){
            this.$axios.post('/api/wechat1/seatdisconnectlist',{
                imid:this.imid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.stsid=res.data.data.stsid
                    this.detail=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
                
            })
        }
    }

}
</script>


// WEBPACK FOOTER //
// src/components/chat/settime.vue